import type { ShapeTextAlignment } from "@gettactic/map-builder/src/types";
import React from "react";

export interface CaptionTextProps {
  text: string;
  /** Width of the shape the caption sits under. */
  width: number;
  top: number;
  textAlign?: ShapeTextAlignment;
  fontSize: number;
  fontFamily: string;
  isBold?: boolean;
  isItalic?: boolean;
  isUnderline?: boolean;
  color: string;
}

/** Label under an icon or furniture piece, in the shape's local space. */
export const CaptionText: React.FC<CaptionTextProps> = ({
  text,
  width,
  top,
  textAlign,
  fontSize,
  fontFamily,
  isBold,
  isItalic,
  isUnderline,
  color
}) => {
  const x =
    textAlign === "center" ? width / 2 : textAlign === "right" ? width : 0;
  const textAnchor =
    textAlign === "center" ? "middle" : textAlign === "right" ? "end" : "start";
  return (
    <text
      x={x}
      y={top}
      textAnchor={textAnchor}
      dominantBaseline="hanging"
      style={{
        fontSize: `${fontSize}px`,
        fontFamily,
        fontWeight: isBold ? "700" : "300",
        fontStyle: isItalic ? "italic" : "normal",
        textDecoration: isUnderline ? "underline" : "none",
        fill: color
      }}
    >
      {text.split("\n").map((line, index) => (
        <tspan
          // biome-ignore lint/suspicious/noArrayIndexKey: lines have no identity of their own
          key={index}
          x={x}
          dy={index === 0 ? 0 : "1.2em"}
          dominantBaseline="hanging"
        >
          {line}
        </tspan>
      ))}
    </text>
  );
};
